export default "__VITE_ASSET__DkIPgrsj__"